import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const AdminAudit = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-audit-page">
      <p className="font-label text-[11px] uppercase tracking-[0.22em] text-rose/70 mb-1">Operations</p>
      <h1 className="font-hero text-3xl text-cream mb-6">Audit log</h1>
      {items.length === 0 ? (
        <p className="text-cream/75">No activity yet.</p>
      ) : (
        <div className="rounded-2xl overflow-hidden" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
          <table className="w-full text-sm text-cream/80">
            <thead>
              <tr className="text-left font-label text-[11px] uppercase tracking-[0.22em] text-cream/65 border-b border-white/10">
                <th className="py-3 px-4">When</th><th>Actor</th><th>Action</th><th>Target</th><th>Details</th>
              </tr>
            </thead>
            <tbody>
              {items.map(i => (
                <tr key={i.id} className="border-b border-white/10 last:border-b-0">
                  <td className="py-3 px-4 text-cream/60">{new Date(i.at).toLocaleString()}</td>
                  <td className="text-cream">{i.actor}</td>
                  <td>
                    <span className="font-label text-[10px] uppercase tracking-[0.22em] px-2 py-1 rounded-full" style={{ background: "rgba(155,143,191,0.18)", color: "#C6BFE1" }}>{i.action}</span>
                  </td>
                  <td>{i.target || "—"}</td>
                  <td className="text-cream/75">{Object.keys(i.details || {}).length ? JSON.stringify(i.details) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminAudit;
